import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import BgTheme1 from '@/components/bg-theme-1.vue';
import PaymentMenuComponent from '@/components/payment/payment-menu.vue';
import SelectTransactionComponent from '@/components/payment/payment-select-transaction.vue';


@Component({
  components: {
    BgTheme1,
    PaymentMenuComponent,
    SelectTransactionComponent
  }
})
export default class PaymentComponent extends Vue {
  public toggle = false;
  public paymentMenu: ('menu' | 'select-transaction') = 'menu';

  mounted() {
    this.paymentMenu = 'select-transaction';
    // setTimeout(() => {
    //   this.toggle = true;
    // }, 3000)
  }
}


